import React, { PureComponent } from 'react';
import Reflux from 'reflux';
import PrintableCuesheetStore from 'flux/stores/cuesheet.printable/PrintableCuesheetStore';
import PDFExportFormStore from 'flux/stores/cuesheet.printable/PDFExportFormStore';
import PDFExportPresetOptions from 'main/components/show/cuesheet.printable/pdfExportForm/presetOptions';
import PDFExportLayoutOptions from 'main/components/show/cuesheet.printable/pdfExportForm/layoutOptions';
import PDFExportExtraOptions, {
  extraOptionsFields,
} from 'main/components/show/cuesheet.printable/pdfExportForm/extraOptions';
import PDFExportColumnVisibility from 'main/components/show/cuesheet.printable/pdfExportForm/columnVisibility';
import PrintableCuesheet from 'main/components/show/cuesheet.printable/cuesheet.jsx';
import PDFExportFormActions from 'flux/actions/cuesheet.printable/PDFExportFormActions';
import IntercomActions from 'flux/actions/IntercomActions';
import GrayDivider from 'shared/components/form/grayDivider.jsx';
import { Icon } from '@shoflo-rundown/polymer.legacy';
import { List, Map } from 'immutable';
import { Row, Col, Button, ButtonGroup } from 'bootstrap';
import classNames from 'classnames';
import { isChrome } from 'shared/lib/browserCheck';

// NOTE THIS FILE HAS MANY PROP TYPE VIOLATIONS
// AND ALL ARE DISABLED BY THE COMMENT BELOW.
/* eslint-disable react/prop-types */

export default React.createClass({
  displayName: 'PDFExport',

  mixins: [
    Reflux.connect(PDFExportFormStore, 'form'),
    Reflux.connect(PrintableCuesheetStore, 'cuesheet'),
  ],

  getInitialState() {
    return {
      hasEditedCustomPageBreaks: false,
      usingCustomPageBreaks: false,
      viewingPDFPreview: false,
      showColumnOptions: true,
      showExtraOptions: false,
    };
  },

  componentDidMount() {
    PDFExportFormActions.submit();
    IntercomActions.hideChat(true);
  },

  componentWillUnmount() {
    IntercomActions.hideChat(false);
  },

  render() {
    const { viewingPDFPreview } = this.state;

    const contentNode = (
      <div className="fullscreen-modal-pdf-preview">
        {this._getContentViewToggleNode()}
        {viewingPDFPreview
          ? this._getRenderedPDFNode()
          : this._getPageBreakEditingNode()}
      </div>
    );

    //due to differences in how browswers handle flexbox, chrome needs
    //height to be set to 100% on this div
    const style = isChrome() ? { height: '100%' } : {};

    return (
      <div className="fullscreen-modal-pdf-export-grid" style={style}>
        {this._getSideMenuNode()}
        {contentNode}
      </div>
    );
  },

  _getContentViewToggleNode() {
    const { viewingPDFPreview } = this.state;

    const removeBreaksNode = !viewingPDFPreview ? (
      <a
        onClick={() => {
          PDFExportFormActions.updateField('customPageBreaks', List());
        }}
      >
        Remove custom breaks
      </a>
    ) : null;

    return (
      <div className="pdf-view-toggle-wrapper">
        <ButtonGroup>
          <Button
            className={classNames({ active: !viewingPDFPreview })}
            onClick={() => {
              this.setState({ viewingPDFPreview: false });
            }}
          >
            Edit Mode
          </Button>
          <Button
            className={classNames({ active: viewingPDFPreview })}
            onClick={() => {
              this.setState({ viewingPDFPreview: true });
            }}
          >
            Preview Mode
          </Button>
        </ButtonGroup>
        {removeBreaksNode}
      </div>
    );
  },

  _getSideMenuNode() {
    const { showColumnOptions, showExtraOptions, form } = this.state;

    // const downloading = form.get('downloading');

    let extraOptionProps = Map();

    extraOptionsFields.forEach((field) => {
      extraOptionProps = extraOptionProps.set(field, form.get(field));
    });

    //firefox doesnt calculate heights properly with flexbox so the height
    //must be set explicitly by subtracting the header and footer height
    const style = { maxHeight: `calc(100vh - 104px - 96px)` };

    return (
      <div className="pdf-options-side-panel">
        <div className="pdf-options" style={style}>
          <PDFExportPresetOptions
            pdfPresets={form.get('pdfPresets')}
            activePresetId={form.get('activePresetId')}
            transientPresetChange={form.get('transientPresetChange')}
          />
          <PDFExportLayoutOptions
            form={form}
            onClick={(field, value) =>
              PDFExportFormActions.updateField(field, value)
            }
          />
          <ToggleMenuPanel
            title="Column Visibility"
            expanded={showColumnOptions}
            onToggle={() =>
              this.setState({
                showColumnOptions: showColumnOptions ? false : true,
              })
            }
          >
            <PDFExportColumnVisibility
              allColumns={form.get('allColumns')}
              includePrivateNoteContents={form.get(
                'includePrivateNoteContents',
              )}
              onColumnToggleClick={(columnId, visibility) =>
                PDFExportFormActions.updateColumnVisibility(
                  columnId,
                  visibility,
                )
              }
              onPrivateNotesToggleClick={(includePrivateNoteContents) =>
                PDFExportFormActions.updateField(
                  'includePrivateNoteContents',
                  !includePrivateNoteContents,
                )
              }
            />
          </ToggleMenuPanel>
          <GrayDivider margin={6} />
          <ToggleMenuPanel
            title="Additional Options"
            expanded={showExtraOptions}
            onToggle={() =>
              this.setState({
                showExtraOptions: showExtraOptions ? false : true,
              })
            }
          >
            <PDFExportExtraOptions
              onToggle={(fieldToToggle, fieldValue) =>
                PDFExportFormActions.updateField(
                  fieldToToggle,
                  fieldValue ? false : true,
                )
              }
              options={extraOptionProps}
            />
          </ToggleMenuPanel>
        </div>
        <div className="pdf-options-footer">
          <GrayDivider margin={0} />
          <div className="pdf-options-footer-button-wrapper">
            <a
              className={classNames('btn-download', {
                disabled: !form.has('pdfUrl'),
              })}
              href={form.get('pdfUrl')}
              download
              target="_blank"
              rel="noopener noreferrer"
              disabled={!form.has('pdfUrl')}
            >
              {!form.has('pdfUrl') ? 'Generating PDF...' : 'Download PDF'}
            </a>
          </div>
        </div>
      </div>
    );
  },

  _getPageBreakEditingNode() {
    const { form } = this.state;

    return (
      <div className="pdf-preview-body-outer-wrapper">
        <PDFPreviewBodyWrapper>
          {this._getEditModeHeader()}
          <PrintableCuesheet
            classes="printable-cuesheet"
            type="export"
            pageBreaks={form.get('customPageBreaks')}
            pageBreakEditingMode
          />
        </PDFPreviewBodyWrapper>
      </div>
    );
  },

  _getEditModeHeader() {
    const { cuesheet } = this.state;

    const displayTeamTitle = cuesheet.get('displayTeamTitle');
    const displayTeamLogo = cuesheet.get('displayTeamLogo');
    const displayEventTitle = cuesheet.get('displayEventTitle');
    const displayEventLogo = cuesheet.get('displayEventLogo');
    const displayShowTitle = cuesheet.get('displayShowTitle');

    const eventTitle = cuesheet.getIn(['event', 'title']);
    const showTitle = cuesheet.getIn(['show', 'title']);
    const teamTitle = cuesheet.getIn(['team', 'title']);

    const eventLogo = cuesheet.getIn(['event', 'photo']);
    const teamLogo = cuesheet.getIn(['team', 'photo']);

    const eventTitleNode = displayEventTitle ? eventTitle : '';
    const showTitleNode = displayShowTitle ? showTitle : '';
    const teamTitleNode = displayTeamTitle ? teamTitle : '';

    const eventImage =
      displayEventLogo && eventLogo ? (
        <img alt="event-logo" src={eventLogo} />
      ) : null;

    const teamImageNode =
      displayTeamLogo && teamLogo ? (
        <img
          alt="team-logo"
          style={{
            height: '24px',
            width: 'auto',
            display: 'block',
            margin: 'auto',
          }}
          src={teamLogo}
        />
      ) : null;

    return (
      <Row className="pdf-edit-mode-header">
        <Col lg={8} md={8} sm={8}>
          <div className="show-event-title-wrapper">
            <span>{eventTitleNode}</span>
            <span>{showTitleNode}</span>
          </div>
        </Col>
        <Col lg={8} md={8} sm={8}>
          <div className="event-logo-wrapper">{eventImage}</div>
        </Col>
        <Col lg={8} md={8} sm={8}>
          <div className="team-image-title-outer-wrapper">
            <div className="team-image-title-inner-wrapper">
              <span>{teamImageNode}</span>
              <span>{teamTitleNode}</span>
            </div>
          </div>
        </Col>
      </Row>
    );
  },

  _getRenderedPDFNode() {
    const { form } = this.state;

    const url = form.get('pdfUrl');

    if (!url) {
      return (
        <span style={{ marginTop: 30 }} className="text-center">
          Loading...
        </span>
      );
    }

    return <PDFIFrame url={url} />;
  },
});

class PDFIFrame extends PureComponent {
  render() {
    const { url } = this.props;

    return (
      <iframe
        title="pdf-preview"
        width="100%"
        height="100%"
        src={url}
        frameBorder="0"
        allowFullScreen
      />
    );
  }
}

const PDFPreviewBodyWrapper = ({ children }) => {
  return (
    <div className="pdf-preview-body-inner-wrapper">
      <div className="pdf-preview-body-outer-scroll">
        <div className="pdf-preview-body-inner-scroll">
          <div id="pdf-preview-body">{children}</div>
        </div>
      </div>
    </div>
  );
};

const ToggleMenuPanel = ({ title, expanded, children, onToggle }) => {
  return (
    <div className="pdf-export-toggle-menu-panel">
      <div
        className="pdf-export-toggle-menu-title"
        onClick={(e) => {
          const element = e.target;
          onToggle();
          setTimeout(function () {
            element.scrollIntoView();
          }, 100);
        }}
      >
        <h4>{title}</h4> <Icon name={`angle-${expanded ? 'down' : 'up'}`} />
      </div>
      {expanded && <div>{children}</div>}
    </div>
  );
};
